/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BuildingOfficeAltIcon16Light } from './BuildingOfficeAltIcon16Light';
import { BuildingOfficeAltIcon16Regular } from './BuildingOfficeAltIcon16Regular';
import { BuildingOfficeAltIcon16Solid } from './BuildingOfficeAltIcon16Solid';
import { BuildingOfficeAltIcon20Light } from './BuildingOfficeAltIcon20Light';
import { BuildingOfficeAltIcon20Regular } from './BuildingOfficeAltIcon20Regular';
import { BuildingOfficeAltIcon20Solid } from './BuildingOfficeAltIcon20Solid';
import { BuildingOfficeAltIcon24Regular } from './BuildingOfficeAltIcon24Regular';
import { BuildingOfficeAltIcon24Solid } from './BuildingOfficeAltIcon24Solid';
import { BuildingOfficeAltIcon32Regular } from './BuildingOfficeAltIcon32Regular';
import { BuildingOfficeAltIcon64Regular } from './BuildingOfficeAltIcon64Regular';
var sizes = {
    16: {
        light: BuildingOfficeAltIcon16Light,
        regular: BuildingOfficeAltIcon16Regular,
        solid: BuildingOfficeAltIcon16Solid,
    },
    20: {
        light: BuildingOfficeAltIcon20Light,
        regular: BuildingOfficeAltIcon20Regular,
        solid: BuildingOfficeAltIcon20Solid,
    },
    24: {
        regular: BuildingOfficeAltIcon24Regular,
        solid: BuildingOfficeAltIcon24Solid,
    },
    32: {
        regular: BuildingOfficeAltIcon32Regular,
    },
    64: {
        regular: BuildingOfficeAltIcon64Regular,
    },
};
export var BuildingOfficeAltIcon = forwardRef('BuildingOfficeAltIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
